// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-gx5","icon":"styles_icon__1nAdF"};